





















import { Component, Vue } from 'vue-property-decorator'
import SlideBar from '@/apps/open/views/fileCenter/components/SlideBar.vue'
import DocRate from './components/DocRate.vue'
import privateDocMenu from './PrivateDocMenu.json'

@Component({
  components: {
    SlideBar,
    DocRate
  }
})
export default class EnterpriseInnerApp extends Vue {
  sliderBarOpeneds = ['', '']
  slideBarActive = ''
  breadList = []
  dropdownList = []
  dropdownSelectUrl = ''

  created () {
    this.initSlideBar(this.$route.path)
    this.initBreadcrumb(this.$route)
  }

  beforeRouteUpdate (to: any, from: any, next: any) {
    this.initSlideBar(to.path)
    this.initBreadcrumb(to)
    next()
  }

  mounted () {
    window.addEventListener('scroll', this.onBodyScroll, true)
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get fileCenterMenu () {
    const publicDocMenu = [
      {
        path: '/docs/doc-format-conversion/access-know',
        name: '接入须知',
        icon: ''
      },
      {
        path: '/docs/doc-format-conversion/api-list',
        name: 'Api列表',
        icon: ''
      },
      {
        path: '/docs/doc-format-conversion/sign-desc',
        name: '签名说明',
        icon: ''
      },
      {
        path: '/docs/doc-format-conversion/demo',
        name: 'DEMO',
        icon: ''
      },
      {
        path: '/docs/doc-format-conversion/error-code',
        name: '常见错误码',
        icon: ''
      },
      {
        path: '/docs/doc-format-conversion/charge-standard',
        name: '计费说明',
        icon: ''
      }
    ]
    return this.isPrivate ? privateDocMenu.doc_format_conversion : publicDocMenu
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.onBodyScroll, true)
  }

  onBodyScroll () {
    let scrollTop = document.body.scrollTop + document.documentElement.scrollTop
    let elHeaderHeight = document.getElementsByClassName('el-header')[0].clientHeight
    let elAside = document.getElementsByClassName('el-aside')[0] as HTMLElement
    let elMain = document.getElementsByClassName('el-main')[0] as HTMLElement
    let elBreadCrumb = document.getElementsByClassName('el-breadcrumb')[0] as HTMLElement

    if (scrollTop > elHeaderHeight) {
      elAside.style.position = 'fixed'
      elAside.style.top = '66px'
      elMain.style.marginLeft = '231px'
      elBreadCrumb.style.position = 'fixed'
      elBreadCrumb.style.top = '66px'
    } else {
      elAside.style.position = 'relative'
      elAside.style.top = '0px'
      elMain.style.marginLeft = '0px'
      elBreadCrumb.style.position = 'relative'
      elBreadCrumb.style.top = '0px'
    }
  }

  initSlideBar (toIndex: string) {
    this.slideBarActive = toIndex
  }

  initBreadcrumb (curRoute: any) {
    let matched = curRoute.matched.filter((item: any) => item.meta.title)
    this.breadList = matched
    this.dropdownList = curRoute.meta.aimtilelist
  }

  dropdownItemOnclick (index: number) {
    this.dropdownSelectUrl = '#s' + index
  }
}
